import React from 'react'
import PropTypes from 'prop-types'
import { Item, Label, Content } from './styles'

export default function DescItemList({ label, children }) {
  return (
    <Item>
      <Label>{label}</Label>
      <Content>
        {children}
      </Content>
    </Item>
  )
}

DescItemList.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
}

DescItemList.defaultProps = {
  children: null,
}
